module.exports = __webpack_public_path__ + "static/media/add-user.660cff5f.svg";